import { createSelector } from 'reselect'
import { selectCurrentUserIsAdminOrOwner } from 'ducks/currentUser/selectors/base'
import { selectIsTestAccount } from 'selectors/account'

import {
  selectIsInboxBootstrapped,
  isBoostrappedSelector,
} from 'selectors/app/base'
import { selectPrefersShowDemoMailbox } from './app/selectAccountPreferences'
import { selectKnownMailboxes, selectMailboxIds } from './mailboxes_base'
import { selectIsCurrentDemoMailbox } from './mailboxes'

const selectMailboxCountExclDemo = createSelector(
  selectKnownMailboxes,
  selectIsTestAccount,
  (mailboxes, isTestAccount) => {
    return (mailboxes || []).filter(
      mailbox => isTestAccount || mailbox.state !== 'demo'
    ).length
  }
)

const selectMailboxCountExclDemoAndUnconfirmed = createSelector(
  selectKnownMailboxes,
  selectIsTestAccount,
  (mailboxes, isTestAccount) => {
    return (mailboxes || []).filter(
      mailbox =>
        isTestAccount ||
        (mailbox.state !== 'demo' && mailbox.state !== 'unconfirmed')
    ).length
  }
)

export const selectHasRealMailboxes = createSelector(
  isBoostrappedSelector,
  selectMailboxCountExclDemo,
  (bootstrapped, count) => bootstrapped && count > 0
)

export const selectHasRealConfirmedMailboxes = createSelector(
  isBoostrappedSelector,
  selectMailboxCountExclDemoAndUnconfirmed,
  (bootstrapped, count) => bootstrapped && count > 0
)

export const selectShowInboxesEmptyPage = createSelector(
  selectIsInboxBootstrapped,
  selectMailboxIds,
  selectMailboxCountExclDemo,
  selectPrefersShowDemoMailbox,
  selectCurrentUserIsAdminOrOwner,
  (bootstrapped, mailboxIds, exclDemoCount, allowDemoMailbox, isManager) => {
    if (!bootstrapped || !isManager) return false
    const fullCount = mailboxIds.length
    if (allowDemoMailbox) return fullCount === 0
    return exclDemoCount === 0
  }
)

export const selectShowDemoInboxCard = createSelector(
  selectCurrentUserIsAdminOrOwner,
  selectIsCurrentDemoMailbox,
  selectKnownMailboxes,
  (isManager, isDemoMailbox, mailboxes) => {
    // HACK (jscheel): We have a 5 year old bug with the way we store the mailbox
    // id in localStorage. Sometimes the current mailbox is null when it really isn't.
    // This doesn't happen often, but accounting for the issue here.
    const onlyDemoMailbox =
      mailboxes.length === 1 && mailboxes[0].state === 'demo'

    return isManager && isDemoMailbox && onlyDemoMailbox
  }
)

export const selectShowDemoMailboxLink = createSelector(
  selectShowInboxesEmptyPage,
  selectKnownMailboxes,
  (showEmpty, mailboxes) => showEmpty && mailboxes.some(m => m.state === 'demo')
)
